import React from 'react';

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.9 8c0-3.81-3.09-6.9-6.9-6.9s-6.9 3.09-6.9 6.9 3.09 6.9 6.9 6.9 6.9-3.09 6.9-6.9m-6.9 8c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.089 3.996c-.048-.535.374-.996.911-.996s.959.46.911.996l-.548 6.172c-.017.188-.174.332-.363.332s-.346-.144-.363-.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16h-16z"
  }))));
};
SvgError.displayName = "Error";

export { SvgError as S };
